import { Button, STYLE_NONE } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent, useState } from 'react';
import './ImagePreviewModalBody.scss';

export interface ImagePreviewModalBodyProps {
    imageUrl: string;
}

const ImagePreviewModalBody: FunctionComponent<ImagePreviewModalBodyProps> = ({
    imageUrl,
}) => {
    const [isImageMaximized, setIsImageMaximized] = useState(false);

    const toggleImageMaximizedState = () =>
        setIsImageMaximized(!isImageMaximized);

    const body = isImageMaximized ? (
        <img
            data-spec="addon-form__full-image"
            src={imageUrl}
            alt={gettext('Full Size').toString()}
        />
    ) : (
        <div
            data-spec="addon-form__contained-image"
            className="addon-form__image-container"
            style={{ backgroundImage: `url(${imageUrl})` }}
        />
    );

    return (
        <div
            className={classNames(
                'addon-form__image-preview',
                isImageMaximized
                    ? 'addon-form__image-preview--full'
                    : 'addon-form__image-preview--small',
            )}
        >
            <Button style={STYLE_NONE} onClick={toggleImageMaximizedState}>
                {body}
            </Button>
        </div>
    );
};
export default ImagePreviewModalBody;
